import { IBaseResponseData, IHouseCommunication } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of houseCommunications from the `/house-communication`
 * endpoint.
 */
export interface IHouseCommunicationResponse extends IBaseResponseData {
  houseCommunications: IHouseCommunication[]
}
